import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        browserTitle: "",
        res: {
            loading: false,
            shadow: false,
            excludeList: 'applicationdetail,createres,search'
        },
    },
    mutations: {
        SET_BROWSERTITLE(state,action){
            state.browserTitle = action
        },
        OPEN_LOADING(state) {
            state.res.loading = true
        },
        CLOSE_LOADING(state) {
            state.res.loading = false
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js